import { transitionMotorInsuranceDeclarationsForm } from '../../../actions/ugMotorInsurance/declarations';
import { FIELD_STATUS } from '../../../reducers/status';
import { getDeclarationsForm } from '../../../selectors/ugMotorInsurance/declarations';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const declarationsFormRules = (store, next, action) => {
    const result = next(action);
    const declarationsForm = getDeclarationsForm(store.getState());
    const declarationsFormValid = validateDeclarationsFormDetails(declarationsForm);
    const formAction = declarationsFormValid
        ? transitionMotorInsuranceDeclarationsForm.formValid()
        : transitionMotorInsuranceDeclarationsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateDeclarationsFormDetails = (formFields) => {
    if (gatsbyStack === 'ke') {
        return true;
    } else {
        return (
            formFields.stickerCollection &&
            formFields.stickerCollection.status === FIELD_STATUS.VALID &&
            formFields.soleOwnership &&
            formFields.soleOwnership.status === FIELD_STATUS.VALID &&
            formFields.purchaseAgreement &&
            formFields.purchaseAgreement.status === FIELD_STATUS.VALID &&
            formFields.parking &&
            formFields.parking.status === FIELD_STATUS.VALID &&
            formFields.domesticPurposes &&
            formFields.domesticPurposes.status === FIELD_STATUS.VALID &&
            formFields.businessPurposes &&
            formFields.businessPurposes.status === FIELD_STATUS.VALID &&
            formFields.employeeUse &&
            formFields.employeeUse.status === FIELD_STATUS.VALID &&
            formFields.tradeGoodsUse &&
            formFields.tradeGoodsUse.status === FIELD_STATUS.VALID &&
            formFields.otherPurposeUse &&
            formFields.otherPurposeUse.status === FIELD_STATUS.VALID
        );

        /*
         console.log(
            'Declarations are valid:',
            !!(
                formFields.stickerCollection?.value &&
                formFields.soleOwnership?.value &&
                formFields.purchaseAgreement?.value &&
                formFields.parking?.value &&
                formFields.domesticPurposes?.value &&
                formFields.businessPurposes?.value &&
                formFields.employeeUse?.value &&
                formFields.tradeGoodsUse?.value &&
                formFields.otherPurposeUse?.value
            )
        );

 return !!(
            formFields.stickerCollection?.value &&
            formFields.soleOwnership?.value &&
            formFields.purchaseAgreement?.value &&
            formFields.parking?.value &&
            formFields.domesticPurposes?.value &&
            formFields.businessPurposes?.value &&
            formFields.employeeUse?.value &&
            formFields.tradeGoodsUse?.value &&
            formFields.otherPurposeUse?.value
        );
        */
        // return true;
    }
};
